import './settings.scss';
import Logo from '../../assets/logo-small.svg';
import { useNavigate } from "react-router-dom";
import Button from '../../components/button/button';
import FooterClient from '../../components/footer-client/footer-client';
import ModalChangePassword from '../../components/modal-change-password/modal-change-password';
import AuthService from '../../services/auth-service';
import TranslateService from '../../services/translate-service';
import LocalStorage from '../../services/local-storage';
import { useState, useRef } from 'react';
import { SESSION, ASSETS, LANGUAGE, ES, EN, PT } from '../../constants';
import Avatar from  '../../components/avatar/avatar';

export default function Settings() {

    const navigate = useNavigate();    

    const inputFile = useRef(null);

    const [session, setSession] = useState(LocalStorage.get(SESSION));
    const [language] = useState(LocalStorage.get(LANGUAGE));
    const [showModal, setShowModal] = useState(false);

    const handleLanguage = (lang) => {
        if(lang !== language) {
            LocalStorage.set(LANGUAGE, lang);

            navigate(0);
        }
    }
 
    const handleAvatar = async (event) => {
        if(!event.target.files[0]) return;

        let form = new FormData();
        form.append('avatar', event.target.files[0])
        
        const response = await AuthService.setAvatar(session._id, form);

        let sessionTMP = {...session};
        sessionTMP.avatar = response.avatar;

        LocalStorage.set(SESSION, sessionTMP);

        inputFile.current.value = '';
        setTimeout( () => setSession(sessionTMP) )
    }


    return (
        <>
            <ModalChangePassword isOpen={showModal}  onClose={() => setShowModal(false)}/> 

            <div className='settings'>
                <div className="pb-16 ">
                    <div className='container  mx-auto px-4'>

                        <div className='flex items-center w-full pt-11 pb-5'>
                            <div className='flex items-center '>
                                <img src={Logo} alt="" />
                            </div>
                        </div>

                        <div className='grid gap-[16px] grid-cols-12'>
                            <div className='col-span-8 col-start-3'>
                                <div className=''>
                                    <Button className='link !text-[#000000] !font-normal' onClick={() => navigate(-1)}>{TranslateService.get('settings.back.btn')}</Button>
                                </div>

                                <div className='card mt-5'>
                                    <div className='heading-h6 uppercase pb-5 separator-bottom'>
                                        💫 {TranslateService.get('settings.title')}
                                    </div>

                                    <div className='grid gap-[16px] grid-cols-12 py-11 separator-bottom items-center'>
                                        <div className='col-span-3'>
                                            <p>{TranslateService.get('settings.profile.title')}</p>
                                            <p className='text-sm text-secundary mt-2'>{TranslateService.get('settings.profile.description')}</p>
                                        </div>
                                        <div className='col-span-9'>
                                            <div className='flex items-center'>
                                                <div>
                                                    <Avatar className='mx-auto !w-[56px] !h-[56px]' image={ `${ASSETS.AVATAR_PLAYER}${session.avatar}` }/>
{/* 
                                                    <div className='rounded-full avatar m-auto w-[56px] h-[56px]' style={{ backgroundImage: `url("${  }")` }}>
                                                    </div> */}
                                                </div>
                                                <div className='ml-5'>
                                                    <Button className='link' onClick={ () => inputFile.current.click() }>{TranslateService.get('settings.profile.btn')}</Button>
                                                    <input type='file' accept=".png,.jpg,.jpeg" className='hidden' ref={inputFile} onChange={ event => handleAvatar(event)} />
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                  
                                    <div className='grid gap-[16px] grid-cols-12 py-11 separator-bottom items-center'>
                                        <div className='col-span-3'>
                                            <p>{TranslateService.get('settings.security.title')}</p>
                                            <p className='text-sm text-secundary mt-2'>{TranslateService.get('settings.security.description')}</p>
                                        </div>
                                        <div className='col-span-9'>
                                            <Button className='small' onClick={setShowModal}>{TranslateService.get('settings.security.btn')}</Button>
                                        </div>
                                    </div>
                                  
                                    <div className='grid gap-[16px] grid-cols-12 py-11 separator-bottom '>
                                        <div className='col-span-3'>
                                            <p>{TranslateService.get('settings.platform.title')}</p>
                                            <p className='text-sm text-secundary mt-2'>{TranslateService.get('settings.platform.description')}</p>
                                        </div>
                                        <div className='col-span-9'>

                                            <p>{TranslateService.get('settings.platform.subtitle')}</p>

                                            <ul className='btn-languages mt-2'>
                                                <li className={ language === ES ? 'selected' : '' } onClick={() =>handleLanguage(ES)}>Español</li>
                                                <li className={ language === EN ? 'selected' : '' } onClick={() =>handleLanguage(EN)}>English</li>
                                                <li className={ language === PT ? 'selected' : '' } onClick={() =>handleLanguage(PT)}>Português</li>
                                            </ul>
                                        </div>
                                    </div>
                                  
                                    <div className='grid gap-[16px] grid-cols-12 py-11'>
                                        <div className='col-span-3'>
                                            <p>{TranslateService.get('settings.about.title')}</p>
                                        </div>
                                        <div className='col-span-9'>
                                            <div className='flex items-start'>
                                                <img src={Logo} alt="" />
                                                <div className='ml-5'>
                                                    <p>Welcome to Gameif</p>
                                                    <p className='text-sm text-secundary mt-1'>
                                                        A training product developed by Loft Media Latam S.C. 
                                                        <br />
                                                        Read our Privacy policy  and terms and conditions
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='text-center'>
                                    <p className='text-sm text-secundary mt-5'>
                                    {TranslateService.get('settings.contactus')} <a href='mailto:soporte@gameif.media' target='_blank' rel="noreferrer" className='underline font-bold'>soporte@gameif.media</a>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <FooterClient />
                    </div>
                </div>
            </div>
        </>
    )

}